import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Observable } from 'rxjs';
import { HotelSummaryModel } from '@core/models/domains/hotel';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';

@Component({
  selector: 'iho-faq',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, MatIconModule],
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  animations: [
    trigger('expandAccordionPanel', [
      state('visible', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('visible <=> hidden', animate('500ms ease-in-out')),
    ]),
  ],
})
export class FaqComponent implements OnInit {
  @Input() set dataSource(value: any) {
    this.hotelInfoSummery = value;
  }

  ngOnInit(): void {}

  aboutHotelsectionTemplate!: string;

  hotelInfoSummery!: HotelSummaryModel;

  faqList: { question: string; answer: string }[] = [];
}
